import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Project } from 'src/app/core/_models/project';
import { Solution } from 'src/app/core/_models/solution';
import { SolutionService } from 'src/app/core/_services/solution.service';
import { SpinnerOverlayService } from 'src/app/core/_services/spinner.overlay.service';

export interface DialogSelectSolutionData {
  projects?: Project[];
  versionId?: string;
}

@Component({
  selector: 'app-dialog-select-solution',
  templateUrl: './dialog-select-solution.component.html',
  styleUrls: ['./dialog-select-solution.component.scss']
})
export class DialogSelectSolutionComponent implements OnInit {
  projects: Project[] = [];
  filteredProjects: Project[] = [];
  selectedProject: Project | null = null;
  isLoading: boolean = true;

  constructor(
    public dialogRef: MatDialogRef<DialogSelectSolutionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogSelectSolutionData,
    private solutionService: SolutionService,
    private spinnerService: SpinnerOverlayService
  ) {}

  ngOnInit(): void {
    if (this.data.projects && this.data.projects.length > 0) {
      this.setProjects(this.data.projects);
      this.isLoading = false;
      return;
    }
    this.spinnerService.show();
    this.solutionService.getAllGroupedByProject(this.data.versionId).subscribe((projects) => {
      this.setProjects(projects);
      this.spinnerService.hide();
      this.isLoading = false;
    });
  }

  private setProjects(projects: Project[]): void {
    this.projects = projects.sort((a, b) => (a.displayName || '').localeCompare(b.displayName || '') || (a.code || '').localeCompare(b.code || ''));
    this.filteredProjects = [...this.projects];
    this.selectedProject = this.filteredProjects[0] || null;
  }

  onProjectSelect(project: Project): void {
    this.selectedProject = project;
  }

  onSolutionSelect(solution: Solution): void {
    this.dialogRef.close(solution);
  }

  trackByProjectId(_index: number, project: Project): string {
    return project.id || project.displayName || String(_index);
  }

  trackBySolutionId(_index: number, solution: Solution): string {
    return solution.id || solution.displayName || String(_index);
  }

  search(target: any) {
    const filterValue = (target.value || '').trim().toLowerCase();

    if (!filterValue) {
      this.filteredProjects = [...this.projects];
      this.selectedProject = this.filteredProjects[0] || null;
      return;
    }

    this.filteredProjects = this.projects
      .map((project) => {
        const newProject = { ...project };
        const projectMatch = newProject.displayName?.toLowerCase().includes(filterValue) || newProject.code?.toLowerCase().includes(filterValue);
        const matchingSolutions = newProject.solutions?.filter((solution) => solution.displayName?.toLowerCase().includes(filterValue));

        newProject.solutions = projectMatch ? newProject.solutions : matchingSolutions;

        if (projectMatch || (matchingSolutions && matchingSolutions.length > 0)) return newProject;

        return null;
      })
      .filter((project): project is Project => project !== null);

    this.selectedProject = this.filteredProjects[0] || null;
  }
}
